<app-header></app-header>

<!-- Hero Start -->
<section class="bg-half-170 d-table w-100 overflow-hidden" id="home">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-6">
        <div class="title-heading">
          <h1 class="heading mb-3">{{'Home.HomeHead.Head1' | translate }} <br> {{'Home.HomeHead.Head2' | translate }}
          </h1>
          <p class="para-desc text-muted">{{'Home.HomeHead.p' | translate }}</p>
          <div class="mt-4 pt-2">
            <a routerLink="/signup" class="btn btn-primary">{{'Home.Signup' |translate }}</a>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="classic-saas-image position-relative">
          <div class="bg-saas-shape position-relative">
            <img [src]="imageUrl" fetchpriority="high" loading="eager" width="1200" height="600"
              class="mx-auto d-block logo" alt="Mockup">
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- start About Us -->
<section class="about-us">
  <div class="container">

    <div class="section-title justify-content-center pb-2 text-center">
      <h4 class="title mt-3 mb-4">{{ 'Home.How.HowItWork' | translate }}</h4>
      <p class="text-muted para-desc mb-0 mx-auto">{{ 'Home.How.p' | translate }}</p>
    </div>

    <div class="row">
      <ng-container *ngFor="let item of howItWorks">
        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
          <div class="card border-0 text-center rounded h-100 d-flex flex-column align-items-center">
            <div class="icons text-primary text-center mx-auto">
              <img [src]="item.icon" [alt]="item.altText" loading="lazy" width="80" height="80">
            </div>
            <div class="card-body p-0 mt-4">
              <span class="title h5 text-dark d-block min-vh-10" [innerText]="item.title | translate"></span>
              <p class="text-muted" [innerText]="item.description | translate"></p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
<!-- End About Us -->


<!-- Start services -->
<section class="services section" id="services">
  <div class="container">
    <div class="section-title justify-content-center text-center mb-4">
      <h4 class="title mb-4">{{ 'Home.Services.OurServices' | translate }}</h4>
    </div>

    <div class="row">
      <div *ngFor="let service of servicesList" class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="service-content rounded elementor-animation-float h-100 d-flex flex-column">

          <!-- Icon block -->
          <div class="icon-service elementor-animation-float" style="min-height: 60px;">
            <i class="{{ service.icon }}" style="font-size: 2rem;"></i>
          </div>

          <!-- Body block -->
          <div class="body-service mt-3 flex-grow-1 d-flex flex-column">
            <h5 class="text-primary text-uppercase min-vh-10">{{ service.title | translate }}</h5>
            <p class="text-muted mb-0 flex-grow-1">{{ service.description | translate }}</p>

            <a [routerLink]="service.link" class="mt-3 align-self-start"  [attr.aria-label]="(service.title | translate) + ' - ' + ('Home.Services.ReadMore' | translate)">
              {{ 'Home.Services.ReadMore' | translate }}
              <i class="fa fa-solid fa-arrow-{{ 'dir-icon' | translate }} py-1 px-2"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End services -->


<!-- start payments options -->
<section class="payments section bg-light">
  <div class="container">
    <div class="section-title justify-content-center text-center mb-4">
      <h4 class="title mb-4" [innerText]="'Home.AcceptAllPaymentMethods' | translate"></h4>
    </div>
    <owl-carousel-o [options]="options">
      <ng-container *ngFor="let slide of PaymentsOptionsArray;let i=index ;trackBy: trackByFn">
        <ng-template carouselSlide>
          <div class="rounded shadow m-2 text-center">
            <img [src]="slide.image" class="img-fluid avatar avatar-ex-sm mx-auto" alt="..." loading="lazy">
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
<!-- End payments options-->

<!-- Start Fees -->
<section class="section">
  <div class="container px-0">
    <div class="row g-0 align-items-top">
      <ng-container *ngFor="let fee of feesArray; let i = index; trackBy: trackByFn">
        <div class="col-xl-2 col-lg-4 col-md-4">
          <div class="fees text-center m-2 p-2">
            <span class="h2 icon2 text-primary">
              <img [src]="'../../../../../assets/images/icons/' + fee.image" [alt]="fee.alt" width="80" height="80"
                loading="lazy">
            </span>
            <div class="card-body p-0 content">
              <h5>{{ fee.title | translate }}</h5>
              <p class="text-muted mb-0">{{ fee.description | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
<!-- End Fees -->


<!-- Start Download App -->
<section class="downloadApp section bg-light">
  <div class="container-download">
    <div class="row download">
      <div class="col-lg-6 p-0">
        <div class="section-title">
          <h1 class="title mb-4">{{ 'Home.DownloadApp.Title' | translate }}</h1>
          <p class="text-muted para-desc mx-auto mb-0">
            {{ 'Home.DownloadApp.Desc1' | translate }} <br>
            {{ 'Home.DownloadApp.Desc2' | translate }} <br>
            {{ 'Home.DownloadApp.Desc3' | translate }}
          </p>
        </div>
        <div class="store py-2">
          <a href="https://play.google.com/store/apps/details?id=com.EasyKash" target="_blank"
            rel="noopener noreferrer">
            <img src="../../../../../assets/images/google-play.webp" alt="Download on Google Play" loading="lazy">
          </a>
          <a href="https://apps.apple.com/eg/app/easykash/id6447126028" target="_blank" rel="noopener noreferrer">
            <img src="../../../../../assets/images/app-store.webp" alt="Download on App Store" loading="lazy">
          </a>
        </div>
      </div>
      <div class="col-lg-6 p-0">
        <div class="mockup-download">
          <img src="../../../../../assets/images/mockup/phone and cards.webp" alt="App Mockup Preview" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Download App -->


<!-- Partner Start -->
<section class="section">
  <div class="container text-center">
    <h3 class="title mb-4">{{ 'Home.EasyKashPaymentPartners' | translate }}</h3>
    <div class="d-flex flex-wrap justify-content-center gap-3">
      <img src="../../../../../assets/images/payment-options/aman.webp" alt="Aman Payment Partner" width="180"
        loading="lazy">
      <img src="../../../../../assets/images/payment-options/efinance.webp" alt="eFinance Payment Partner" width="180"
        loading="lazy">
      <img src="../../../../../assets/images/payment-options/orange logo.webp" alt="Orange Payment Partner" width="180"
        loading="lazy">
      <img src="../../../../../assets/images/payment-options/fawry.webp" alt="Fawry Payment Partner" width="180"
        loading="lazy">
      <img src="../../../../../assets/images/payment-options/bank ahly.webp" alt="Bank Ahly Payment Partner" width="180"
        loading="lazy">
      <img src="../../../../../assets/images/payment-options/bank misr.webp" alt="Bank Misr Payment Partner" width="180"
        loading="lazy">
    </div>
  </div>
</section>


<!-- Start Testimonials -->
<section class="testimonials section bg-light">
  <div class="container-feedback">
    <div class="text-center">
      <h4 class="title mb-4">{{ 'Home.BestFeedbackFromClients' | translate }}</h4>
    </div>
    <div class="my-4">
      <owl-carousel-o [options]="testimonialsOptions">
        <ng-container *ngFor="let slide of feedbackArray; let i = index">
          <ng-template carouselSlide>
            <div class="text-center">
              <p class="text-muted">{{ slide.feedback }}</p>
              <div class="intro">
                <img src="../../../../../assets/images/{{ slide.type }}.webp"
                  class="avatar avatar-small rounded-circle mx-auto shadow-lg" alt="{{ slide.type }} avatar"
                  loading="lazy">

                <div class="mt-3">
                  <ul class="h6 text-warning list-inline mb-0">
                    <li class="list-inline-item" *ngFor="let star of [1,2,3,4,5]">
                      <i class="fa fa-star"></i>
                    </li>
                  </ul>
                  <h5 class="text-primary mb-0">{{ slide.busniessName }}</h5>
                  <small class="text-muted">{{ slide.title }}</small>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
<!-- End Testimonials -->

<!-- Start Counter -->
<section class="section" #counterSection>
  <div class="container mt-5">
    <div class="section-title text-center mb-4">
      <h4 class="title mb-4">
        {{ 'Home.SeeEverything' | translate }}
        <span class="text-primary">{{ 'Home.EasyKash' | translate }}</span>
      </h4>
      <p class="text-muted para-desc mx-auto mb-0">
        {{ 'Home.StartWorking' | translate }}
        <span class="text-primary fw-bold">{{ 'Home.EasyKash' | translate }}</span>
        {{ 'Home.SeeEverythingDesc' | translate }}
      </p>
    </div>

    <div class="row">
      <div class="col-md-3 col-6 mt-4 pt-2" *ngFor="let item of counterData">
        <div class="counter-box text-center">
          <img [src]="'../../../../../assets/images/icons/' + item.icon + '.webp'" class="avatar avatar-small"
            [alt]="item.altText" width="80" height="80" loading="lazy">
          <h2 class="mb-0 mt-4">
            <span class="counter-value" [attr.data-target]="item.target">{{ item.default }}</span>{{ item.suffix }}
          </h2>
          <h6 class="counter-head text-muted">{{ item.label |translate}}</h6>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Counter -->


<!-- Start Client Logo -->
<section class="payments section bg-light">
  <div class="container">
    <div class="section-title text-center mb-4">
      <h4 class="title mb-4">{{ 'Home.Ourclientslogos' | translate }}</h4>
    </div>

    <owl-carousel-o [options]="optionsLogoClient">
      <ng-container *ngFor="let slide of clientsLogoArray; trackBy: trackByFn">
        <ng-template carouselSlide>
          <div class="text-center">
            <div class="logobody rounded shadow-sm m-2">
              <img [src]="slide.image" class="img-fluid avatar avatar-ex-sm mx-auto" [alt]="slide.name" loading="lazy">
              <p class="text-muted small mt-2">{{ slide.name }}</p>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
<!-- End Client Logo -->

<!-- Start Plans -->
<section class="plans py-5">
  <div class="container">
    <div class="section-title text-center mb-4">
      <h4 class="title mb-4">{{ 'Home.Plans.Title' | translate }}</h4>
    </div>

    <div class="content">
      <div *ngFor="let plan of plans; trackBy: trackByFn" class="plan" [ngClass]="{ 'part2': plan.special }">
        <h3>{{ plan.title | translate }}</h3>
        <h3 class="price">{{ plan.price }}<span>/{{ 'Home.Plans.PerTransaction' | translate }}</span></h3>
        <hr />
        <ul>
          <li *ngFor="let desc of plan.description; let i = index" [ngClass]="{ 'bold-text': i === 1 }">
            {{ desc | translate }}
          </li>
        </ul>
        <a [routerLink]="plan.route" class="btn btn-primary">{{ 'Home.Signup' | translate }}</a>
      </div>
    </div>
  </div>
</section>
<!-- End Plans -->


<!-- Call to Action Start -->
<section class="py-5 bg-light" id="counter">
  <div class="section-title text-center">
    <h4 class="title mb-4">
      {{ 'Home.Overall' | translate }}
      <span class="text-primary">
        <span #counterElement>{{ currentCount }}</span>
      </span>
      {{ 'Home.Clients' | translate }}
    </h4>
    <p class="text-muted para-desc mx-auto mb-0">
      {{ 'Home.ClientsDescription' | translate }}
    </p>

    <div class="mt-4">
      <a routerLink="/signup" queryParamsHandling="merge" class="btn btn-primary m-1">
        {{ 'Home.StartForFree' | translate }}
        <i class="fas fa-chevron-right"></i>
      </a>
    </div>
  </div>
</section>
<!-- Call to Action End -->


<app-footer></app-footer>
